import _toConsumableArray from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Pagination from "@/components/Pagination/index.vue";
import { defineComponent, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { Search } from '@element-plus/icons';
import "swiper/swiper.scss";
import Swiper from "swiper";
export default defineComponent({
  name: "BookCase",
  components: {
    Head: Head,
    Pagination: Pagination
  },
  setup: function setup() {
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var category = ref([// { typeId: 1, typeName: "推荐" },
    ]);
    var baseurl = process.env.VUE_APP_BASE_URL;
    var categoryId = ref(0);
    var booklist = ref([{
      bookName: "",
      coverPic: "",
      author: ""
    }]); // 表格加载

    var loading = ref(false);
    var tableloading = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_tableloading; // 列表请求参数

    var listParams = {
      pageIndex: 1,
      pageSize: 12,
      recommend: "1",
      typeId: null,
      bookName: ""
    }; // 第一个table的初始化

    var bookNum = ref(0);
    var pageIndex = ref(1); // 获取书籍

    function getAllBookbyPage() {
      return _getAllBookbyPage.apply(this, arguments);
    }

    function _getAllBookbyPage() {
      _getAllBookbyPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data, total;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading.value = true;
                _context.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getAllBookbyPage"](listParams);

              case 3:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                total = _yield$globalProperti.total;
                // data.push(...data)
                // data.push(...data)
                // data.push(...data)
                booklist.value = _toConsumableArray(data);
                bookNum.value = total;
                loading.value = false;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getAllBookbyPage.apply(this, arguments);
    }

    function toDetail(res) {
      router.push({
        name: "myBookCaseDetail",
        query: {
          id: res.bookId
        }
      });
    } //获取分类不分页


    function getBookClassification() {
      return _getBookClassification.apply(this, arguments);
    }

    function _getBookClassification() {
      _getBookClassification = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$globalProperti2, code, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getBookClassificationNoPage"]();

              case 2:
                _yield$globalProperti2 = _context2.sent;
                code = _yield$globalProperti2.code;
                data = _yield$globalProperti2.data;

                if (code == 0) {
                  category.value = data;
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getBookClassification.apply(this, arguments);
    }

    function changeCategory(res) {
      categoryId.value = res;

      if (res == 0) {
        listParams = {
          pageIndex: 1,
          pageSize: 12,
          recommend: "1",
          typeId: null,
          bookName: ""
        };
      } else {
        listParams = {
          pageIndex: 1,
          pageSize: 12,
          recommend: "",
          typeId: res,
          bookName: ""
        };
      }

      getAllBookbyPage();
    } //查看排行


    var Rank = function Rank() {
      router.push({
        name: "myBookCase"
      });
    };

    function changPage(val) {
      listParams.pageIndex = val;
      getAllBookbyPage();
    }

    getAllBookbyPage();
    onMounted(function () {
      getBookClassification();
      new Swiper('.swiper-container', {
        autoHeight: true,
        slidesPerView: 'auto',
        observer: true
      });
    });
    var searchContent = ref();

    function searchBook() {
      if (searchContent.value == '') {
        listParams = {
          pageIndex: 1,
          pageSize: 12,
          recommend: "1",
          typeId: null,
          bookName: ""
        };
        categoryId.value = 0;
        getAllBookbyPage();
        return;
      }

      categoryId.value = -1;
      listParams = {
        pageIndex: 1,
        pageSize: 12,
        recommend: "",
        typeId: null,
        bookName: searchContent.value
      };
      getAllBookbyPage();
    }

    return {
      baseurl: baseurl,
      category: category,
      categoryId: categoryId,
      changeCategory: changeCategory,
      booklist: booklist,
      bookNum: bookNum,
      getBookClassification: getBookClassification,
      getAllBookbyPage: getAllBookbyPage,
      tableloading: tableloading,
      loading: loading,
      pageIndex: pageIndex,
      toDetail: toDetail,
      Rank: Rank,
      changPage: changPage,
      Search: Search,
      searchBook: searchBook,
      searchContent: searchContent
    };
  }
});